/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_PageInputs */

const en_common_page = /** @type {(inputs: Common_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page`)
};

const es_common_page = /** @type {(inputs: Common_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Página`)
};

/**
* | output |
* | --- |
* | "Page" |
*
* @param {Common_PageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_page = /** @type {((inputs?: Common_PageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_PageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_page(inputs)
	return en_common_page(inputs)
});